<template>
  <div class="plagin-wrapper" v-if="config && config.src" :style="{height:swiperHeight && swiperHeight + 'px'}">
    <img class="show-for-md image__fit" :src="config.src.pc" @click="actionHandler(config.action)" alt="Sisley Paris" />
    <img class="hide-for-md image__fit" :src="config.src.h5" @click="actionHandler(config.action)" alt="Sisley Paris" />
  </div>
</template>

<script>
import acitonMixins from "@/utils/action.mixins";

export default {
  name: 'ImageBanner',
  mixins: [acitonMixins],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  created() {
    if(window.innerWidth < 1024){
      this.swiperHeight = window.innerWidth / 750 * 1070
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
  .plagin-wrapper {
    box-sizing: border-box; width: 100vw; height: calc(100vh - 63px); 
    overflow: hidden;
    img { width: 100%; height: 100%; object-fit: cover; object-position: center; cursor: pointer; }
  }
  
  @media screen and (min-width: 64em) {
    .plagin-wrapper { height: 100vh; }
  }

  @media (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .plagin-wrapper .image__fit {
      width: 100%; height: auto;
      position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    }
  }
</style>